export const HPV_TARGET_CONVERSATIONS = 10;
export const HPV_SUBSIDY_QR_URL = '/hpv-subsidy-qr.jpg';

export const getRemainingHpvConversations = (completedRounds) => (
    Math.max(0, HPV_TARGET_CONVERSATIONS - Number(completedRounds || 0))
);
